import { SET_ADMIN_USER_DETAILS, UPDATE_ADMIN_USER_DETAILS } from '../actions';

const INITIAL_STATE = null;

const userDetailsReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_ADMIN_USER_DETAILS: {
               return action.payload;
          }

          case UPDATE_ADMIN_USER_DETAILS: {
               const newState = { ...state };

               const newUser = {
                    ...newState,
                    ...action.payload,
               };

               return newUser;
          }

          default:
               return state;
     }
};

export default userDetailsReducer;
